import { createElement, memo, ReactNode, Suspense } from "react";
import { LoadingIndicator, LoadingIndicatorProps } from "../../ui/LoadingIndicator";
import { useGlobalLoaderRemover } from "../GlobalLoaderRemover";

import styles from "./styles.module.scss";

export type PageLoaderProps = LoadingIndicatorProps & {
  children?: ReactNode | ReactNode[]
}

export const PageLoader = memo<PageLoaderProps>(({ children, ...props }) => {
  return (
    <Suspense fallback={
      <LoadingIndicator
        loadingIndicatorSize={"md"}
        loadingIndicatorType={"lineSimple"}
        loadingIndicatorLabel={""}
        className={styles.loader}
        {...props}
      />
    }
    >
      {children}
    </Suspense>
  );
});

export const PageLoaderWithRemover = memo<PageLoaderProps>((props) => {
  useGlobalLoaderRemover();
  return createElement(PageLoader, props);
});

export function withPageLoader(children: ReactNode | ReactNode[], withRemover = true, props?: Omit<PageLoaderProps, "children">) {
  return createElement(withRemover ? PageLoaderWithRemover : PageLoader, props, children);
}